<div class="tab-bar">
  @if (isShowNav()) {
    <div
      (click)="onNavLeft($event)"
      [class.tab-bar__nav--hidden]="isDisableNavLeft()"
      class="tab-bar__nav tab-bar__nav--left"
    >
      <div matRipple class="tab-bar__nav-button">
        <mat-icon class="tab-bar__nav-icon" [class.tab-bar__nav-icon--disabled]="isDisableNavLeft()">
          chevron_left
        </mat-icon>
      </div>
    </div>
    <div
      (click)="onNavRight($event)"
      [class.tab-bar__nav--hidden]="isDisableNavRight()"
      class="tab-bar__nav tab-bar__nav--right"
    >
      <div matRipple class="tab-bar__nav-button">
        <mat-icon class="tab-bar__nav-icon" [class.tab-bar__nav-icon--disabled]="isDisableNavRight()">
          chevron_right
        </mat-icon>
      </div>
    </div>
  }
  <div #tabNav class="tab-bar__list">
    @for (item of tabs(); track $index) {
      <div
        class="tab-bar__tab"
        [class.tab-bar__tab--active]="isTabSelected(item.index)"
        (click)="onSelectTab(item); $event.stopPropagation()"
      >
        <span class="tab-bar__label">
          {{ item.title | translate }}
          @if (item.count != null) {
            <span class="tab-bar__count">{{ item.count }}</span>
          }
        </span>
      </div>
    }
  </div>
</div>
